import { render } from "./ArgonAlert.vue?vue&type=template&id=467d3f18&scoped=true"
import script from "./ArgonAlert.vue?vue&type=script&lang=js"
export * from "./ArgonAlert.vue?vue&type=script&lang=js"

import "./ArgonAlert.vue?vue&type=style&index=0&id=467d3f18&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467d3f18"]])

export default __exports__